import { AxiosError } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getResponseError } from '@utils/error';
import { SagaPayload } from '@utils/typescript';
import { UserPasswordApi } from '@apis/UserPasswordApi';
import {
  passwordUpdate,
  UpdatePasswordPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handlePasswordUpdate({ payload }: SagaPayload<UpdatePasswordPayload>) {
  try {
    yield call(UserPasswordApi.update, payload);
    const state: StateUpdatePayload = { isSuccess: true, serverErrors: {} };
    yield put(stateUpdate(state));
  } catch (e) {
    const { errors } = getResponseError(e as AxiosError);
    const state: StateUpdatePayload = { isSuccess: false, serverErrors: errors };
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(passwordUpdate, handlePasswordUpdate);
}
